import React, { FC } from 'react';

import LeftSidebar from '@buyside/components/presentation/RankingsIndexPage/LeftSidebar/leftSidebar';
import MainContent from '@buyside/components/presentation/RankingsIndexPage/MainContent/mainContent';

import styles from './rankingsIndexPageStyles.scss';

const RankingsIndexPage: FC<{ isPublic?: boolean }> = ({ isPublic = false }) => {
  return (
    <div className={styles.rankingsIndexPage}>
      <LeftSidebar />
      <MainContent isPublic={isPublic} />
    </div>
  );
};

export default RankingsIndexPage;
